<template>
  <nav><Navigation /></nav>
  <router-view />
  <footer><Footer></Footer></footer>
</template>

<script setup>
import Navigation from "./components/Navigation.vue";
import Footer from "./components/Footer.vue";
</script>

<style lang="scss">
@font-face {
  font-family: Raleway;
  src: url("@/assets/Raleway-VariableFont_wght.ttf");
}
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
html {
  font-family: Raleway;
  font-size: 16px;
  height: 100%;
  -webkit-font-feature-settings: "lnum" 1;
  -moz-font-feature-settings: "lnum" 1;
  -moz-font-feature-settings: "lnum=1";
  -ms-font-feature-settings: "lnum" 1;
  -o-font-feature-settings: "lnum" 1;
  font-feature-settings: "lnum" 1;
  @media (min-width: 1440px) {
    font-size: 20px;
  }
}
html,
body {
  -webkit-font-smoothing: subpixel-antialiased;
  text-rendering: optimizeLegibility;
}
body {
  font-family: "Raleway", sans-serif;
  height: 100%;
  font-size: 1rem;
  background-color: $bg--col;
  color: $text--col;
}
p {
  font-size: 1.25rem;
  letter-spacing: 0.25px;
  line-height: 1.7;
  max-width: 45em;
  color: $text--greyed;
  font-weight: 430;
}
a {
  font-size: 1rem;
  letter-spacing: 0.25px;
  text-decoration: none;
  font-family: Raleway;
}
h1 {
  font-size: 3.125rem;
  @media (max-width: 400px) {
    font-size: 2.815rem;
  }
  letter-spacing: -0.15px;
  color: $text--col;
  line-height: 1.2;
  font-weight: 750;
}
h2 {
  font-size: 2rem;
  font-weight: 550;
  letter-spacing: 0.25px;
}
h3 {
  font-size: 1.25rem;
  letter-spacing: 0.25px;
  font-weight: 450;
}
//utility
.global-container {
  padding: map-get($spaces, "sm");
  position: relative;
  @media (min-width: 768px) {
    padding: map-get($spaces, "lg");
  }
  @media (min-width: 1440px) {
    padding: map-get($spaces, "xxl");
  }
}
.space-1 {
  height: 50vh;
}
.space-2 {
  height: 25vh;
}
.space-3 {
  height: 12.5vh;
}
//responisveness
@media (min-width: 768px) {
  html {
    font-size: 18px;
  }
  h1 {
    font-size: 3.875rem;
    letter-spacing: -1px;
  }
  h2 {
    font-size: 2.615rem;
    letter-spacing: 0.25px;
  }
  h3 {
    font-size: 1.5625rem;
    letter-spacing: 0;
  }
}
</style>
